export async function getAppointmentById(id) {
  const res = await window.axios({
    method: 'GET',
    baseURL: process.env.VUE_APP_API_ADMIN_LOCATION,
    url: `appointments/${id}`,
  });
  return res.data.data;
}
